import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models (j209/models/j209.go)
// ============================================================

export interface FJ180 {
  fj180_01: string;        // 繳庫單號 (PK)
  fj180_11: string | null; // 繳庫日期 (ISO date)
  fj180_12: string;        // varchar(10)
  fj180_13: string;        // varchar(100)
  fj180_14: number;        // integer
  fj180_15: string;        // 繳庫庫位
  fj180_16: string;        // 部門代號
  fj180_17: string;        // 入單人員
  fj180_18: number;        // 總項次
  fj180_80: string;        // 核准狀態 P/空
  fj180_89: string;
  fj180_90: number;        // version
  fj180_91: string;        // 修改人
  fj180_92: string | null; // 修改日期
  fj180_93: string;        // 建立人

  // Associations
  details?: FJ181[];
}

export interface FJ181 {
  fj181_01: string;   // 繳庫單號 FK
  fj181_02: number;   // 項次
  fj181_10: string;   // 庫位代號
  fj181_11: string;   // 產品代號前6
  fj181_12: string;   // 產品代號後6
  fj181_13: string;   // 庫存帳Key
  fj181_14: string;   // 單位
  fj181_15: number;   // 繳庫數量
  fj181_16: string;   // 色號
  fj181_161: string;  // 中文色名
  fj181_162: string;  // 英文色名
  fj181_16a: string;  // CBNO.
  fj181_17: number;   // 碼重
  fj181_18: number;   // 備用欄18
  fj181_19: string;   // 產品名稱
  fj181_20: string;   // 產品規格
  fj181_21: string;   // 加工別
  fj181_22: number;   // 幅寬
  fj181_23: number;   // 針孔內
  fj181_24: number;   // 針孔外
  fj181_25: number;   // 重量
  fj181_26: string;   // 板號
  fj181_27: string;   // 等級
  fj181_271: string;  // 等級說明
  fj181_90: number;
}

// ============================================================
// Request / Response types
// ============================================================

export interface J209ListResponse {
  data: FJ180[];
  total: number;
  page: number;
  size: number;
}

export interface J209CreateRequest {
  master: Partial<FJ180>;
  details: Partial<FJ181>[];
}

// ============================================================
// API methods
// ============================================================

export const j209Api = {
  async list(page = 1, size = 20): Promise<J209ListResponse> {
    const res = await apiClient.get('/api/j209', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FJ180> {
    const res = await apiClient.get(`/api/j209/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: J209CreateRequest): Promise<FJ180> {
    const res = await apiClient.post('/api/j209', data);
    return res.data;
  },

  async update(id: string, data: J209CreateRequest): Promise<FJ180> {
    const res = await apiClient.put(`/api/j209/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/j209/${encodeURIComponent(id)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/j209/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
